import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-83402a7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header header-desktop" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "header-main" }
const _hoisted_4 = { class: "menu-links" }
const _hoisted_5 = { class: "header-search" }
const _hoisted_6 = {
  key: 0,
  class: "header-actions header-actions-logged"
}
const _hoisted_7 = {
  key: 1,
  class: "header-actions"
}
const _hoisted_8 = { class: "menu-links" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button primary" }, "Join for Free", -1))
const _hoisted_10 = { class: "header header-mobile" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "header-search" }
const _hoisted_13 = {
  key: 0,
  class: "header-user-avatar-wrapper"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 1,
  class: "fullscreen-menu"
}
const _hoisted_16 = { class: "menu-links" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "menu-hr" }, null, -1))
const _hoisted_18 = {
  key: 0,
  class: "menu-links"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = {
  key: 1,
  class: "menu-links"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "button primary" }, "Join for Free", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: { name: $setup.routesName.landing }
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: $setup.logoSrc,
            alt: "nexusmedx"
          }, null, 8, _hoisted_2)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.menuLinks, (item, index) => {
            return _createVNode(_component_router_link, {
              class: "menu-link",
              key: index,
              to: { name: item.routeName }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode($setup["AppTextField"], {
            modelValue: $setup.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.search) = $event)),
            modelModifiers: { trim: true },
            placeholder: "Search by topic..."
          }, null, 8, ["modelValue"])
        ])
      ]),
      ($setup.isLoggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode($setup["HeaderUserPanel"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_link, {
                class: "menu-link",
                to: { name: $setup.routesName.login }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Login")
                ]),
                _: 1
              }, 8, ["to"])
            ]),
            _createVNode(_component_router_link, {
              to: { name: $setup.routesName.registration }
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "hamburger-button",
        "aria-label": "Menu",
        onClick: $setup.toggleMenu
      }),
      _createVNode(_component_router_link, {
        to: { name: $setup.routesName.landing }
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            class: "logo",
            src: $setup.logoShortSrc,
            alt: "nexusmedx"
          }, null, 8, _hoisted_11)
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode($setup["AppTextField"], {
          modelValue: $setup.search,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.search) = $event)),
          modelModifiers: { trim: true },
          placeholder: "Search by topic..."
        }, null, 8, ["modelValue"])
      ]),
      ($setup.isLoggedIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            ($setup.userStore.userData?.avatar)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "header-user-avatar",
                  src: $setup.userStore.userData?.avatar?.presets['150x150'] || $setup.userStore.userData?.avatar?.url,
                  alt: "avatar image",
                  onClick: $setup.toggleMenu
                }, null, 8, _hoisted_14))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "header-user-avatar",
                  onClick: $setup.toggleMenu
                }, _toDisplayString($setup.userStore.getUserAbbr()), 1))
          ]))
        : _createCommentVNode("", true),
      ($setup.isMenuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.menuLinks, (item, index) => {
                return _createVNode(_component_router_link, {
                  class: "menu-link",
                  key: index,
                  to: { name: item.routeName }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              }), 64))
            ]),
            _hoisted_17,
            ($setup.isLoggedIn)
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userMenuOptions, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "menu-link",
                      key: index
                    }, [
                      (!!item.action)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => ($setup.onMenuItem(item.action))
                          }, _toDisplayString(item.label), 9, _hoisted_19))
                        : (_openBlock(), _createBlock(_component_router_link, {
                            key: 1,
                            to: { name: item.routeName }
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["to"]))
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    to: { name: $setup.routesName.registration }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_21
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  _createVNode(_component_router_link, {
                    class: "menu-link",
                    to: { name: $setup.routesName.login }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Login")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}